export default {

  dbh_country_cn: '中国',
  dbh_country_tw: '中国台湾',
  dbh_country_mo: '中国澳门',
  dbh_country_hk: '中国香港',
  dbh_country_dk: '丹麦',
  dbh_country_uy: '乌拉圭',
  dbh_country_ye: '也门',
  dbh_country_il: '以色列',
  dbh_country_iq: '伊拉克',
  dbh_country_ru: '俄罗斯',
  dbh_country_cd: '刚果（金）',
  dbh_country_ly: '利比亚',
  dbh_country_ca: '加拿大',
  dbh_country_hu: '匈牙利',
  dbh_country_za: '南非',
  dbh_country_qa: '卡塔尔',
  dbh_country_in: '印度',
  dbh_country_id: '印度尼西亚',
  dbh_country_ec: '厄瓜多尔',
  dbh_country_sy: '叙利亚',
  dbh_country_co: '哥伦比亚',
  dbh_country_tr: '土耳其',
  dbh_country_eg: '埃及',
  dbh_country_mx: '墨西哥',
  dbh_country_at: '奥地利',
  dbh_country_bd: '孟加拉',
  dbh_country_ng: '尼日利亚',
  dbh_country_pk: '巴基斯坦',
  dbh_country_py: '巴拉圭',
  dbh_country_bh: '巴林',
  dbh_country_br: '巴西',
  dbh_country_gr: '希腊',
  dbh_country_de: '德国',
  dbh_country_it: '意大利',
  dbh_country_cz: '捷克',
  dbh_country_ma: '摩洛哥',
  dbh_country_sg: '新加坡',
  dbh_country_nz: '新西兰',
  dbh_country_jp: '日本',
  dbh_country_cl: '智利',
  dbh_country_sa: '沙特阿拉伯',
  dbh_country_fr: '法国',
  dbh_country_pl: '波兰',
  dbh_country_th: '泰国',
  dbh_country_au: '澳大利亚',
  dbh_country_ie: '爱尔兰',
  dbh_country_bo: '玻利维亚',
  dbh_country_se: '瑞典',
  dbh_country_ch: '瑞士',
  dbh_country_kw: '科威特',
  dbh_country_pe: '秘鲁',
  dbh_country_tn: '突尼斯',
  dbh_country_jo: '约旦',
  dbh_country_us: '美国',
  dbh_country_fi: '芬兰',
  dbh_country_gb: '英国',
  dbh_country_nl: '荷兰',
  dbh_country_ph: '菲律宾',
  dbh_country_sv: '萨尔瓦多',
  dbh_country_pt: '葡萄牙',
  dbh_country_es: '西班牙',
  dbh_country_vn: '越南',
  dbh_country_dz: '阿尔及利亚',
  dbh_country_om: '阿曼',
  dbh_country_ar: '阿根廷',
  dbh_country_ae: '阿联酋',
  dbh_country_kr: '韩国',
  dbh_country_my: '马来西亚',
  dbh_country_lb: '黎巴嫩',


}